import { createFileRoute } from "@tanstack/react-router";

import { BaseEditCreateModal } from "@/components/_Modals/BaseEditCreateModal";
import { UsersForm } from "@/features/dashboard/usuarios/components/UsersForm";

export const Route = createFileRoute("/_private/dashboard/_base/usuarios/cadastrar/modal")({
  component: () => (
    <BaseEditCreateModal title="Criar novo Usuário" from="/dashboard/usuarios/cadastrar">
      <UsersForm />
    </BaseEditCreateModal>
  )
});
